import React, { useState, useContext } from "react";
import { Box, Radio, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { SelectUsersDialog } from "../../../case/dialogs/select-users/select-users.dialog";
import { CreateUseCaseContext } from "../../../../store";
import { teamColumns } from "../../../../statics/table-columns/team-columns";
import { TableColumn } from "../../../../types/table-column";
import { formatDate } from "../../../../helpers";
import "./modal-question-handler.component.scoped.scss";
import { UserRoles } from "../../../../types/userRoles";

interface ModalQuestionHandlerProps {
  onAnswer: (isFirstTimeSubmit: boolean, users: any[]) => void;
  isEditing?: boolean;
}

const ModalQuestionHandler: React.FC<ModalQuestionHandlerProps> = ({
  onAnswer,
  isEditing = false,
}) => {
  const { t } = useTranslation();
  const { useCase, setUseCase } = useContext(CreateUseCaseContext);
  const [showUserModal, setShowUserModal] = useState(false);
  const [userImageError, setUserImageError] = useState(false);
  const [isFirstTimeSubmit, setIsFirstTimeSubmit] = useState(true);

  // Auto-open modal when editing starts
  React.useEffect(() => {
    if (isEditing) {
      setShowUserModal(true);
    }
  }, [isEditing]);

  React.useEffect(() => {
    setTimeout(() => {
      setShowUserModal(true);
    }, 1000);
  }, []);

  const onUpdateKeyContactUser = (id: number) => {
    if (!useCase.users || useCase.users.length === 0) return;

    const updatedUsers = useCase.users.map((user: any) => {
      return {
        ...user,
        keyContact: Number(user.id) === Number(id),
      };
    });
    setUseCase({ ...useCase, users: updatedUsers });
    setIsFirstTimeSubmit(false);
  };

  return (
    <>
      {useCase.users && useCase.users.length > 0 ? (
        <Box className="content">
          <Box className="table-section my-4">
            <Box className="tab-head mb-4 d-flex justify-content-between align-items-center">
              <Box className="head">
                <Typography variant="h5" className="title">
                  {t("ASSIGNED_USERS")}
                </Typography>

                <Typography variant="body2" className="sub-title">
                  {`${useCase.users?.length || 0} ${t("USER")} 
              (${
                useCase.users?.filter(
                  (item: any) => item.role === UserRoles.EDITOR,
                ).length || 0
              } ${t("ROLES.EDITOR")} / ${
                    useCase.users?.filter(
                      (item: any) => item.role === UserRoles.AUDITOR,
                    ).length || 0
                  } ${t("ROLES.AUDITOR")} / ${
                    useCase.users?.filter(
                      (item: any) => item.role === UserRoles.CONTRIBUTOR,
                    ).length || 0
                  } ${t("ROLES.CONTRIBUTOR")}
              )`}
                </Typography>
              </Box>
            </Box>

            <Box className="tab-table">
              {/* Table Columns */}
              <Box className="tab-table-header">
                <Box className="d-flex align-items-center justify-content-between">
                  {teamColumns.map((column: TableColumn, index: number) => {
                    return (
                      <Box
                        className="tab-table-column"
                        key={index}
                        style={{ width: column.width }}
                      >
                        {t(column.fieldName)}
                      </Box>
                    );
                  })}
                </Box>
              </Box>
              {/* Table Rows */}

              <Box className="tab-table-body">
                {/* {useCase.users && useCase.users.length === 0 && (
                <Box className="no-result">{t("NO_USERS_SELECTED_YET")}</Box>
              )} */}

                {useCase.users?.map((row: any, rowIndex: number) => {
                  return (
                    <Box
                      className="tab-table-row d-flex justify-content-between"
                      key={rowIndex}
                    >
                      {teamColumns.map(
                        (column: TableColumn, columnIndex: number) => {
                          const { type, value, secondaryValue }: any = column;
                          return (
                            <Box
                              className={
                                "tab-table-cell " +
                                (type === "string" ? " trim" : "")
                              }
                              key={columnIndex}
                              style={{ width: column.width }}
                            >
                              {type === "string" ? (
                                row[value]
                              ) : type === "date" ? (
                                formatDate(row[value], "DD.MM.YYYY")
                              ) : type === "client" ? (
                                <Box
                                  className="d-flex align-items-center"
                                  style={{ gap: ".5rem" }}
                                >
                                  <Box className="user__profile__pic">
                                    {row.profilePicURL && !userImageError ? (
                                      <img
                                        src={row.profilePicURL}
                                        alt=""
                                        onError={setUserImageError.bind(
                                          null,
                                          true,
                                        )}
                                      />
                                    ) : (
                                      <span className="text-uppercase">
                                        {row.firstName[0] + row.lastName[0]}
                                      </span>
                                    )}
                                  </Box>
                                  <Box>
                                    <Box className="user-cell text-capitalize">
                                      {row.firstName + " " + row.lastName}
                                    </Box>
                                    <Box className="branch-name">
                                      {t(`ROLES.${row.role}`) +
                                        "/" +
                                        t(`${row[secondaryValue]}`)}
                                    </Box>
                                  </Box>
                                </Box>
                              ) : type === "keyContact" ? (
                                <Box>
                                  <Radio
                                    checked={row.keyContact}
                                    onChange={(e: any) => {
                                      onUpdateKeyContactUser(e.target.value);
                                    }}
                                    value={row.id}
                                    name="radio-buttons"
                                  />
                                </Box>
                              ) : type === "email" ? (
                                <Box className="user-cell">{row[value]}</Box>
                              ) : (
                                <Box className={type}>{row[value]}</Box>
                              )}
                            </Box>
                          );
                        },
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : null}

      {showUserModal && (
        <SelectUsersDialog
          show={showUserModal}
          onClose={(value: boolean, users: any[]) => {
            setShowUserModal(false);
            onAnswer(isFirstTimeSubmit, users); // Always up-to-date users
            setIsFirstTimeSubmit(false);
          }}
          disableClose={useCase.users && useCase.users.length === 0}
        />
      )}
    </>
  );
};

export default ModalQuestionHandler;
